// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Switch,
//   Button,
//   Table,
//   Modal,
//   Form,
//   Input,
//   message,
//   Space,
//   Tag,
//   Popconfirm,
//   Tabs,
//   Row,
//   Col,
//   Divider,
// } from "antd";
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   BgColorsOutlined,
//   ColumnWidthOutlined,
// } from "@ant-design/icons";
// import settingService from "../services/settingService";

// const { TabPane } = Tabs;

// const Settings = () => {
//   const [loading, setLoading] = useState(false);
//   const [settings, setSettings] = useState(null);
//   const [codEnabled, setCodEnabled] = useState(false);

//   // Size modal states
//   const [sizeModalVisible, setSizeModalVisible] = useState(false);
//   const [sizeEditMode, setSizeEditMode] = useState(false);
//   const [currentSize, setCurrentSize] = useState(null);
//   const [sizeForm] = Form.useForm();

//   // Color modal states
//   const [colorModalVisible, setColorModalVisible] = useState(false);
//   const [colorEditMode, setColorEditMode] = useState(false);
//   const [currentColor, setCurrentColor] = useState(null);
//   const [colorForm] = Form.useForm();

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     try {
//       setLoading(true);
//       const response = await settingService.getSettings();
//       console.log(response, "response");

//       if (response.success) {
//         setSettings(response.data);
//         setCodEnabled(response.data.codEnabled);
//       }
//     } catch (error) {
//       message.error("Failed to fetch settings");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // COD Toggle Handler
//   const handleCodToggle = async (checked) => {
//     try {
//       const response = await settingService.updateCodSetting(checked);
//       if (response.data.success) {
//         setCodEnabled(checked);
//         message.success("COD setting updated successfully");
//       }
//     } catch (error) {
//       message.error("Failed to update COD setting");
//     }
//   };

//   // Size Handlers
//   const handleAddSize = () => {
//     setSizeEditMode(false);
//     setCurrentSize(null);
//     sizeForm.resetFields();
//     setSizeModalVisible(true);
//   };

//   const handleEditSize = (size) => {
//     setSizeEditMode(true);
//     setCurrentSize(size);
//     sizeForm.setFieldsValue({
//       value: size.value,
//       label: size.label,
//       isActive: size.isActive,
//     });
//     setSizeModalVisible(true);
//   };

//   const handleSizeSubmit = async (values) => {
//     try {
//       if (sizeEditMode) {
//         const response = await settingService.updateSize(
//           currentSize._id,
//           values
//         );
//         if (response.data.success) {
//           message.success("Size updated successfully");
//         }
//       } else {
//         const response = await settingService.addSize(values);
//         if (response.data.success) {
//           message.success("Size added successfully");
//         }
//       }
//       setSizeModalVisible(false);
//       sizeForm.resetFields();
//       fetchSettings();
//     } catch (error) {
//       message.error(error.response?.data?.message || "Operation failed");
//     }
//   };

//   const handleDeleteSize = async (id) => {
//     try {
//       const response = await settingService.deleteSize(id);
//       if (response.data.success) {
//         message.success("Size deleted successfully");
//         fetchSettings();
//       }
//     } catch (error) {
//       message.error("Failed to delete size");
//     }
//   };

//   const handleToggleSizeStatus = async (size) => {
//     try {
//       const response = await settingService.updateSize(size._id, {
//         isActive: !size.isActive,
//       });
//       if (response.data.success) {
//         message.success("Size status updated");
//         fetchSettings();
//       }
//     } catch (error) {
//       message.error("Failed to update size status");
//     }
//   };

//   // Color Handlers
//   const handleAddColor = () => {
//     setColorEditMode(false);
//     setCurrentColor(null);
//     colorForm.resetFields();
//     setColorModalVisible(true);
//   };

//   const handleEditColor = (color) => {
//     setColorEditMode(true);
//     setCurrentColor(color);
//     colorForm.setFieldsValue({
//       name: color.name,
//       hexCode: color.hexCode,
//       isActive: color.isActive,
//     });
//     setColorModalVisible(true);
//   };

//   const handleColorSubmit = async (values) => {
//     try {
//       if (colorEditMode) {
//         const response = await settingService.updateColor(
//           currentColor._id,
//           values
//         );
//         if (response.data.success) {
//           message.success("Color updated successfully");
//         }
//       } else {
//         const response = await settingService.addColor(values);
//         if (response.data.success) {
//           message.success("Color added successfully");
//         }
//       }
//       setColorModalVisible(false);
//       colorForm.resetFields();
//       fetchSettings();
//     } catch (error) {
//       message.error(error.response?.data?.message || "Operation failed");
//     }
//   };

//   const handleDeleteColor = async (id) => {
//     try {
//       const response = await settingService.deleteColor(id);
//       if (response.data.success) {
//         message.success("Color deleted successfully");
//         fetchSettings();
//       }
//     } catch (error) {
//       message.error("Failed to delete color");
//     }
//   };

//   const handleToggleColorStatus = async (color) => {
//     try {
//       const response = await settingService.updateColor(color._id, {
//         isActive: !color.isActive,
//       });
//       if (response.data.success) {
//         message.success("Color status updated");
//         fetchSettings();
//       }
//     } catch (error) {
//       message.error("Failed to update color status");
//     }
//   };

//   // Table Columns
//   const sizeColumns = [
//     {
//       title: "Value",
//       dataIndex: "value",
//       key: "value",
//     },
//     {
//       title: "Label",
//       dataIndex: "label",
//       key: "label",
//     },
//     {
//       title: "Status",
//       dataIndex: "isActive",
//       key: "isActive",
//       render: (isActive, record) => (
//         <Switch
//           checked={isActive}
//           onChange={() => handleToggleSizeStatus(record)}
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//         />
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="link"
//             icon={<EditOutlined />}
//             onClick={() => handleEditSize(record)}
//           >
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure you want to delete this size?"
//             onConfirm={() => handleDeleteSize(record._id)}
//             okText="Yes"
//             cancelText="No"
//           >
//             <Button type="link" danger icon={<DeleteOutlined />}>
//               Delete
//             </Button>
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   const colorColumns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//     },
//     {
//       title: "Color",
//       dataIndex: "hexCode",
//       key: "hexCode",
//       render: (hexCode) => (
//         <Space>
//           <div
//             style={{
//               width: 40,
//               height: 40,
//               backgroundColor: hexCode,
//               border: "1px solid #d9d9d9",
//               borderRadius: 4,
//             }}
//           />
//           <span>{hexCode}</span>
//         </Space>
//       ),
//     },
//     {
//       title: "Status",
//       dataIndex: "isActive",
//       key: "isActive",
//       render: (isActive, record) => (
//         <Switch
//           checked={isActive}
//           onChange={() => handleToggleColorStatus(record)}
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//         />
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="link"
//             icon={<EditOutlined />}
//             onClick={() => handleEditColor(record)}
//           >
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure you want to delete this color?"
//             onConfirm={() => handleDeleteColor(record._id)}
//             okText="Yes"
//             cancelText="No"
//           >
//             <Button type="link" danger icon={<DeleteOutlined />}>
//               Delete
//             </Button>
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div style={{ padding: "24px" }}>
//       <Card title="Settings" loading={loading}>
//         <Tabs defaultActiveKey="1">
//           {/* Payment Settings Tab */}
//           <TabPane tab="Payment Settings" key="1">
//             <Card bordered={false}>
//               <Row align="middle" justify="space-between">
//                 <Col>
//                   <Space direction="vertical" size={0}>
//                     <h3 style={{ margin: 0 }}>Cash on Delivery (COD)</h3>
//                     <span style={{ color: "#8c8c8c" }}>
//                       Enable or disable COD payment option for customers
//                     </span>
//                   </Space>
//                 </Col>
//                 <Col>
//                   <Switch
//                     checked={codEnabled}
//                     onChange={handleCodToggle}
//                     checkedChildren="Enabled"
//                     unCheckedChildren="Disabled"
//                     size="large"
//                   />
//                 </Col>
//               </Row>
//             </Card>
//           </TabPane>

//           {/* Sizes Tab */}
//           <TabPane
//             tab={
//               <span>
//                 <ColumnWidthOutlined /> Sizes
//               </span>
//             }
//             key="2"
//           >
//             <div style={{ marginBottom: 16 }}>
//               <Button
//                 type="primary"
//                 icon={<PlusOutlined />}
//                 onClick={handleAddSize}
//               >
//                 Add Size
//               </Button>
//             </div>
//             <Table
//               columns={sizeColumns}
//               dataSource={settings?.sizes || []}
//               rowKey="_id"
//               pagination={false}
//             />
//           </TabPane>

//           {/* Colors Tab */}
//           <TabPane
//             tab={
//               <span>
//                 <BgColorsOutlined /> Colors
//               </span>
//             }
//             key="3"
//           >
//             <div style={{ marginBottom: 16 }}>
//               <Button
//                 type="primary"
//                 icon={<PlusOutlined />}
//                 onClick={handleAddColor}
//               >
//                 Add Color
//               </Button>
//             </div>
//             <Table
//               columns={colorColumns}
//               dataSource={settings?.colors || []}
//               rowKey="_id"
//               pagination={false}
//             />
//           </TabPane>
//         </Tabs>
//       </Card>

//       {/* Size Modal */}
//       <Modal
//         title={sizeEditMode ? "Edit Size" : "Add Size"}
//         open={sizeModalVisible}
//         onCancel={() => {
//           setSizeModalVisible(false);
//           sizeForm.resetFields();
//         }}
//         footer={null}
//       >
//         <Form form={sizeForm} layout="vertical" onFinish={handleSizeSubmit}>
//           <Form.Item
//             name="value"
//             label="Size Value"
//             rules={[{ required: true, message: "Please enter size value" }]}
//           >
//             <Input placeholder="e.g., S, M, L, XL" />
//           </Form.Item>

//           <Form.Item
//             name="label"
//             label="Size Label"
//             rules={[{ required: true, message: "Please enter size label" }]}
//           >
//             <Input placeholder="e.g., Small, Medium, Large" />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button type="primary" htmlType="submit">
//                 {sizeEditMode ? "Update" : "Add"}
//               </Button>
//               <Button
//                 onClick={() => {
//                   setSizeModalVisible(false);
//                   sizeForm.resetFields();
//                 }}
//               >
//                 Cancel
//               </Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Modal>

//       {/* Color Modal */}
//       <Modal
//         title={colorEditMode ? "Edit Color" : "Add Color"}
//         open={colorModalVisible}
//         onCancel={() => {
//           setColorModalVisible(false);
//           colorForm.resetFields();
//         }}
//         footer={null}
//       >
//         <Form form={colorForm} layout="vertical" onFinish={handleColorSubmit}>
//           <Form.Item
//             name="name"
//             label="Color Name"
//             rules={[{ required: true, message: "Please enter color name" }]}
//           >
//             <Input placeholder="e.g., Red, Blue, Green" />
//           </Form.Item>

//           <Form.Item
//             name="hexCode"
//             label="Hex Code"
//             rules={[
//               { required: true, message: "Please enter hex code" },
//               {
//                 pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
//                 message: "Please enter a valid hex code (e.g., #FF0000)",
//               },
//             ]}
//           >
//             <Input
//               placeholder="#FF0000"
//               addonBefore={
//                 <div
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor:
//                       colorForm.getFieldValue("hexCode") || "#ffffff",
//                     border: "1px solid #d9d9d9",
//                   }}
//                 />
//               }
//             />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button type="primary" htmlType="submit">
//                 {colorEditMode ? "Update" : "Add"}
//               </Button>
//               <Button
//                 onClick={() => {
//                   setColorModalVisible(false);
//                   colorForm.resetFields();
//                 }}
//               >
//                 Cancel
//               </Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default Settings;

import React, { useState, useEffect } from "react";
import {
  Card,
  Switch,
  Button,
  Table,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Space,
  Tag,
  Popconfirm,
  Tabs,
  Row,
  Col,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  BgColorsOutlined,
  ColumnWidthOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import settingService from "../services/settingService";
import { toast } from "react-toastify";

const { TabPane } = Tabs;

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(null);
  const [codEnabled, setCodEnabled] = useState(false);

  // Size modal states
  const [sizeModalVisible, setSizeModalVisible] = useState(false);
  const [sizeEditMode, setSizeEditMode] = useState(false);
  const [currentSize, setCurrentSize] = useState(null);
  const [sizeForm] = Form.useForm();

  // Color modal states
  const [colorModalVisible, setColorModalVisible] = useState(false);
  const [colorEditMode, setColorEditMode] = useState(false);
  const [currentColor, setCurrentColor] = useState(null);
  const [colorForm] = Form.useForm();

  // Delivery Fee modal states
  const [deliveryFeeModalVisible, setDeliveryFeeModalVisible] = useState(false);
  const [deliveryFeeEditMode, setDeliveryFeeEditMode] = useState(false);
  const [currentDeliveryFee, setCurrentDeliveryFee] = useState(null);
  const [deliveryFeeForm] = Form.useForm();

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await settingService.getSettings();
      console.log(response, "response");

      if (response?.success && response?.data) {
        setSettings(response.data);
        setCodEnabled(response.data.codEnabled);
      }
    } catch (error) {
      message.error("Failed to fetch settings");
    } finally {
      setLoading(false);
    }
  };

  // COD Toggle Handler
  const handleCodToggle = async (checked) => {
    try {
      const response = await settingService.updateCodSetting(checked);
      console.log(checked, response, "response update");
      if (response?.success) {
        setCodEnabled(checked);
        toast.success("COD setting updated successfully");
      }
    } catch (error) {
      message.error("Failed to update COD setting");
    }
  };

  // Size Handlers
  const handleAddSize = () => {
    setSizeEditMode(false);
    setCurrentSize(null);
    sizeForm.resetFields();
    setSizeModalVisible(true);
  };

  const handleEditSize = (size) => {
    setSizeEditMode(true);
    setCurrentSize(size);
    sizeForm.setFieldsValue({
      value: size.value,
      label: size.label,
      index: size.index || 0,
      isActive: size.isActive,
    });
    setSizeModalVisible(true);
  };

  const handleSizeSubmit = async (values) => {
    try {
      if (sizeEditMode) {
        const response = await settingService.updateSize(
          currentSize._id,
          values
        );
        if (response.data.success) {
          message.success("Size updated successfully");
        }
      } else {
        const response = await settingService.addSize(values);
        if (response.data.success) {
          message.success("Size added successfully");
        }
      }
      setSizeModalVisible(false);
      sizeForm.resetFields();
      fetchSettings();
    } catch (error) {
      message.error(error.response?.data?.message || "Operation failed");
    }
  };

  const handleDeleteSize = async (id) => {
    try {
      const response = await settingService.deleteSize(id);
      if (response.data.success) {
        message.success("Size deleted successfully");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to delete size");
    }
  };

  const handleToggleSizeStatus = async (size) => {
    try {
      const response = await settingService.updateSize(size._id, {
        isActive: !size.isActive,
      });
      if (response.data.success) {
        message.success("Size status updated");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to update size status");
    }
  };

  // Color Handlers
  const handleAddColor = () => {
    setColorEditMode(false);
    setCurrentColor(null);
    colorForm.resetFields();
    setColorModalVisible(true);
  };

  const handleEditColor = (color) => {
    setColorEditMode(true);
    setCurrentColor(color);
    colorForm.setFieldsValue({
      name: color.name,
      hexCode: color.hexCode,
      isActive: color.isActive,
    });
    setColorModalVisible(true);
  };

  const handleColorSubmit = async (values) => {
    try {
      if (colorEditMode) {
        const response = await settingService.updateColor(
          currentColor._id,
          values
        );
        if (response.data.success) {
          message.success("Color updated successfully");
        }
      } else {
        const response = await settingService.addColor(values);
        if (response.data.success) {
          message.success("Color added successfully");
        }
      }
      setColorModalVisible(false);
      colorForm.resetFields();
      fetchSettings();
    } catch (error) {
      message.error(error.response?.data?.message || "Operation failed");
    }
  };

  const handleDeleteColor = async (id) => {
    try {
      const response = await settingService.deleteColor(id);
      if (response.data.success) {
        message.success("Color deleted successfully");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to delete color");
    }
  };

  const handleToggleColorStatus = async (color) => {
    try {
      const response = await settingService.updateColor(color._id, {
        isActive: !color.isActive,
      });
      if (response.data.success) {
        message.success("Color status updated");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to update color status");
    }
  };

  // Delivery Fee Handlers
  const handleAddDeliveryFee = () => {
    setDeliveryFeeEditMode(false);
    setCurrentDeliveryFee(null);
    deliveryFeeForm.resetFields();
    setDeliveryFeeModalVisible(true);
  };

  const handleEditDeliveryFee = (deliveryFee) => {
    setDeliveryFeeEditMode(true);
    setCurrentDeliveryFee(deliveryFee);
    deliveryFeeForm.setFieldsValue({
      name: deliveryFee.name,
      minAmount: deliveryFee.minAmount,
      maxAmount: deliveryFee.maxAmount,
      fee: deliveryFee.fee,
      isActive: deliveryFee.isActive,
    });
    setDeliveryFeeModalVisible(true);
  };

  const handleDeliveryFeeSubmit = async (values) => {
    try {
      if (deliveryFeeEditMode) {
        const response = await settingService.updateDeliveryFee(
          currentDeliveryFee._id,
          values
        );
        if (response.data.success) {
          message.success("Delivery fee updated successfully");
        }
      } else {
        const response = await settingService.addDeliveryFee(values);
        if (response.data.success) {
          message.success("Delivery fee added successfully");
        }
      }
      setDeliveryFeeModalVisible(false);
      deliveryFeeForm.resetFields();
      fetchSettings();
    } catch (error) {
      message.error(error.response?.data?.message || "Operation failed");
    }
  };

  const handleDeleteDeliveryFee = async (id) => {
    try {
      const response = await settingService.deleteDeliveryFee(id);
      if (response.data.success) {
        message.success("Delivery fee deleted successfully");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to delete delivery fee");
    }
  };

  const handleToggleDeliveryFeeStatus = async (deliveryFee) => {
    try {
      const response = await settingService.updateDeliveryFee(deliveryFee._id, {
        isActive: !deliveryFee.isActive,
      });
      if (response.data.success) {
        message.success("Delivery fee status updated");
        fetchSettings();
      }
    } catch (error) {
      message.error("Failed to update delivery fee status");
    }
  };

  // Table Columns
  const sizeColumns = [
    {
      title: "Position",
      dataIndex: "index",
      key: "index",
      sorter: (a, b) => (a.index || 0) - (b.index || 0),
      defaultSortOrder: "ascend",
      render: (index) => index || 0,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          onChange={() => handleToggleSizeStatus(record)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditSize(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this size?"
            onConfirm={() => handleDeleteSize(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const colorColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Color",
      dataIndex: "hexCode",
      key: "hexCode",
      render: (hexCode) => (
        <Space>
          <div
            style={{
              width: 40,
              height: 40,
              backgroundColor: hexCode,
              border: "1px solid #d9d9d9",
              borderRadius: 4,
            }}
          />
          <span>{hexCode}</span>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          onChange={() => handleToggleColorStatus(record)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditColor(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this color?"
            onConfirm={() => handleDeleteColor(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const deliveryFeeColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Order Range",
      key: "range",
      render: (_, record) => (
        <span>
          ₹{record.minAmount} - ₹{record.maxAmount}
        </span>
      ),
    },
    {
      title: "Delivery Fee",
      dataIndex: "fee",
      key: "fee",
      render: (fee) => <Tag color="green">₹{fee}</Tag>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          onChange={() => handleToggleDeliveryFeeStatus(record)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditDeliveryFee(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this delivery fee?"
            onConfirm={() => handleDeleteDeliveryFee(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Card title="Settings" loading={loading}>
        <Tabs defaultActiveKey="1">
          {/* Payment Settings Tab */}
          <TabPane tab="Payment Settings" key="1">
            <Card bordered={false}>
              <Row align="middle" justify="space-between">
                <Col>
                  <Space direction="vertical" size={0}>
                    <h3 style={{ margin: 0 }}>Cash on Delivery (COD)</h3>
                    <span style={{ color: "#8c8c8c" }}>
                      Enable or disable COD payment option for customers
                    </span>
                  </Space>
                </Col>
                <Col>
                  <Switch
                    checked={codEnabled}
                    onChange={handleCodToggle}
                    checkedChildren="Enabled"
                    unCheckedChildren="Disabled"
                    size="large"
                  />
                </Col>
              </Row>
            </Card>
          </TabPane>

          {/* Sizes Tab */}
          <TabPane
            tab={
              <span>
                <ColumnWidthOutlined /> Sizes
              </span>
            }
            key="2"
          >
            <div style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleAddSize}
              >
                Add Size
              </Button>
            </div>
            <Table
              columns={sizeColumns}
              dataSource={[...(settings?.sizes || [])].sort((a, b) => (a.index || 0) - (b.index || 0))}
              rowKey="_id"
              pagination={false}
            />
          </TabPane>

          {/* Colors Tab */}
          <TabPane
            tab={
              <span>
                <BgColorsOutlined /> Colors
              </span>
            }
            key="3"
          >
            <div style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleAddColor}
              >
                Add Color
              </Button>
            </div>
            <Table
              columns={colorColumns}
              dataSource={settings?.colors || []}
              rowKey="_id"
              pagination={false}
            />
          </TabPane>

          {/* Delivery Fees Tab */}
          <TabPane
            tab={
              <span>
                <DollarOutlined /> Delivery Fees
              </span>
            }
            key="4"
          >
            <div style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleAddDeliveryFee}
              >
                Add Delivery Fee
              </Button>
            </div>
            <Table
              columns={deliveryFeeColumns}
              dataSource={settings?.deliveryFees || []}
              rowKey="_id"
              pagination={false}
            />
          </TabPane>
        </Tabs>
      </Card>

      {/* Size Modal */}
      <Modal
        title={sizeEditMode ? "Edit Size" : "Add Size"}
        open={sizeModalVisible}
        onCancel={() => {
          setSizeModalVisible(false);
          sizeForm.resetFields();
        }}
        footer={null}
      >
        <Form form={sizeForm} layout="vertical" onFinish={handleSizeSubmit}>
          <Form.Item
            name="value"
            label="Size Value"
            rules={[{ required: true, message: "Please enter size value" }]}
          >
            <Input placeholder="e.g., S, M, L, XL" />
          </Form.Item>

          <Form.Item
            name="label"
            label="Size Label"
            rules={[{ required: true, message: "Please enter size label" }]}
          >
            <Input placeholder="e.g., Small, Medium, Large" />
          </Form.Item>

          <Form.Item
            name="index"
            label="Position (Display Order)"
            rules={[{ type: "number", message: "Please enter a valid number" }]}
            tooltip="Lower numbers appear first in the size list"
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder="e.g., 1, 2, 3"
              min={0}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {sizeEditMode ? "Update" : "Add"}
              </Button>
              <Button
                onClick={() => {
                  setSizeModalVisible(false);
                  sizeForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* Color Modal */}
      <Modal
        title={colorEditMode ? "Edit Color" : "Add Color"}
        open={colorModalVisible}
        onCancel={() => {
          setColorModalVisible(false);
          colorForm.resetFields();
        }}
        footer={null}
      >
        <Form form={colorForm} layout="vertical" onFinish={handleColorSubmit}>
          <Form.Item
            name="name"
            label="Color Name"
            rules={[{ required: true, message: "Please enter color name" }]}
          >
            <Input placeholder="e.g., Red, Blue, Green" />
          </Form.Item>

          <Form.Item
            name="hexCode"
            label="Hex Code"
            rules={[
              { required: true, message: "Please enter hex code" },
              {
                pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                message: "Please enter a valid hex code (e.g., #FF0000)",
              },
            ]}
          >
            <Input
              placeholder="#FF0000"
              addonBefore={
                <div
                  style={{
                    width: 20,
                    height: 20,
                    backgroundColor:
                      colorForm.getFieldValue("hexCode") || "#ffffff",
                    border: "1px solid #d9d9d9",
                  }}
                />
              }
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {colorEditMode ? "Update" : "Add"}
              </Button>
              <Button
                onClick={() => {
                  setColorModalVisible(false);
                  colorForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* Delivery Fee Modal */}
      <Modal
        title={deliveryFeeEditMode ? "Edit Delivery Fee" : "Add Delivery Fee"}
        open={deliveryFeeModalVisible}
        onCancel={() => {
          setDeliveryFeeModalVisible(false);
          deliveryFeeForm.resetFields();
        }}
        footer={null}
        width={600}
      >
        <Form
          form={deliveryFeeForm}
          layout="vertical"
          onFinish={handleDeliveryFeeSubmit}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter name" }]}
          >
            <Input placeholder="e.g., Standard Delivery, Express Delivery" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="minAmount"
                label="Minimum Order Amount (₹)"
                rules={[
                  { required: true, message: "Please enter minimum amount" },
                  {
                    type: "number",
                    min: 0,
                    message: "Amount must be non-negative",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0"
                  min={0}
                  prefix="₹"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="maxAmount"
                label="Maximum Order Amount (₹)"
                rules={[
                  { required: true, message: "Please enter maximum amount" },
                  {
                    type: "number",
                    min: 0,
                    message: "Amount must be non-negative",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const minAmount = getFieldValue("minAmount");
                      if (!value || !minAmount || value > minAmount) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Max amount must be greater than min amount")
                      );
                    },
                  }),
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="1000"
                  min={0}
                  prefix="₹"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="fee"
            label="Delivery Fee (₹)"
            rules={[
              { required: true, message: "Please enter delivery fee" },
              {
                type: "number",
                min: 0,
                message: "Fee must be non-negative",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder="50"
              min={0}
              prefix="₹"
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {deliveryFeeEditMode ? "Update" : "Add"}
              </Button>
              <Button
                onClick={() => {
                  setDeliveryFeeModalVisible(false);
                  deliveryFeeForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Settings;
